import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { pills as Pills } from '@breezeway/brzw-components';
import { ALIGNMENT } from './constants';
import { TASK_TYPE_STATUS, TASK_READY_TYPE_STATUS } from '../../utils/task';

import './status_pill.scss';

const { PILL_SIZES } = Pills.constants;
const { PILL_TOGGLE_COLORS, PILL_THEMES } = Pills.constants;

const getReadyStatusColor = code => {
  switch (code) {
    case TASK_READY_TYPE_STATUS.INSPECTED:
    case TASK_READY_TYPE_STATUS.CLEANED:
    case TASK_READY_TYPE_STATUS.CLEANING:
    case TASK_READY_TYPE_STATUS.INSPECTING:
      return PILL_TOGGLE_COLORS.GREEN;

    case TASK_READY_TYPE_STATUS.READY:
      return PILL_TOGGLE_COLORS.DARK_GREEN;

    case TASK_READY_TYPE_STATUS.OCCUPIED:
      return PILL_TOGGLE_COLORS.GRAY;

    case TASK_READY_TYPE_STATUS.BLOCKED:
      return PILL_TOGGLE_COLORS.RED;

    case TASK_READY_TYPE_STATUS.DIRTY:
      return PILL_TOGGLE_COLORS.ORANGE;

    default:
      return null;
  }
};

const getStatusIcon = (code, active) => {
  switch (code) {
    case TASK_TYPE_STATUS.IN_PROGRESS:
      return active ? 'play' : 'pause';
    default:
      return null;
  }
};

const StatusPill = ({ active, alignIcon, className, code, name, size, theme, withIcon }) => {
  if (!_.isEmpty(name)) {
    if (theme === PILL_THEMES.LIGHT || theme === PILL_THEMES.FOURTH) {
      return (
        <Pills.Pill
          alignIcon={alignIcon}
          leftIconName="medium-filled"
          readOnly
          size={size}
          statusColors={getReadyStatusColor(code)}
          text={name}
          theme={theme}
          withIcon={withIcon}
        />
      );
    }

    return (
      <Pills.PillToggle
        alignIcon={alignIcon}
        className={`status-pill ${className} status-pill--${code}`}
        disabled
        icon={withIcon && getStatusIcon(code, active)}
        size={size}
        text={name}
      />
    );
  }

  return null;
};

StatusPill.propTypes = {
  active: PropTypes.bool,
  alignIcon: PropTypes.oneOf(_.values(ALIGNMENT)),
  className: PropTypes.string,
  code: PropTypes.string,
  name: PropTypes.string,
  size: PropTypes.oneOf(_.values(PILL_SIZES)),
  theme: PropTypes.oneOf(_.values(PILL_THEMES)),
  withIcon: PropTypes.bool,
};

StatusPill.defaultProps = {
  alignIcon: ALIGNMENT.LEFT,
  className: '',
  size: PILL_SIZES.MEDIUM,
  withIcon: false,
};

export default StatusPill;
